export default __webpack_public_path__ + "static/media/chalk-pointer-left-hand.13b60f58.png";